import { render, staticRenderFns } from "./UIInputFile.vue?vue&type=template&id=5b0128d8&"
import script from "./UIInputFile.vue?vue&type=script&lang=js&"
export * from "./UIInputFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports